import _ from 'lodash'
import { getField, updateField } from 'vuex-map-fields'
import sites from '../mixins/sites.js'
import moment from 'moment'

const defaultSet = {
  item_customer_location: null,
  item_table: {
    success: false
  },
  lasthost: 0,
  delivery: 0,
  item_homedelivery: !sites.computed.isPosApp(),
  item_firma: null,
  item_vorname: null,
  item_name: null,
  item_strasse: null,
  item_hausnummer: null,
  item_geoid: null,
  item_address_addon: null,
  item_handy: null,
  item_email: null,
  item_payment: 'nachnahme',
  item_xtra: null,
  option_cut: false,
  option_bookatable: false,
  option_voucher: false,
  option_agb: false,
  option_email: true,
  option_whatsapp: true,
  item_tip: 0,
  storeCustomerData: true,
  expressCheckout: false,
  item_vytal: {}
}

const state = {
  content: _.merge({}, defaultSet)
}

const actions = {
  setHost ({ state, commit }, hostId) {
    if (state.lasthost !== hostId) {
      console.log('different host -> reset homedelivery')
      commit('resetHomedelivery', hostId)
    }

    commit('setHost', hostId)
  },

  cleanCustomerData ({ state, commit }, keepBasicData) {
    if (keepBasicData) {
      const keepSet = _.pick(state.content, [
        'item_firma',
        'item_vorname',
        'item_name',
        'item_strasse',
        'item_hausnummer',
        'item_geoid',
        'item_address_addon',
        'item_handy',
        'item_email',
        'option_agb',
        'option_email',
        'option_whatsapp'
      ])

      commit('setCustomer', _.merge(defaultSet, keepSet))
    } else {
      commit('setCustomer', defaultSet)
    }
  }
}

const getters = {
  getField,

  hasTable (state) {
    if(moment(state.content.item_table.tableTtl, 'YYYY-MM-DD h:mm:ss').isSameOrBefore(moment())) return false
    return state.content.item_table.success && state.content.item_table.tableHost === state.lasthost
  },

  getTable (state) {
    if(moment(state.content.item_table.tableTtl, 'YYYY-MM-DD h:mm:ss').isSameOrBefore(moment())) return false
    return state.content.item_table
  }
}

const mutations = {
  updateField,

  updateCustomer (state, content) {
    state.content = _.merge(state.content, content)
  },

  setTable (state, content) {
    state.content.item_table = content
  },

  setCustomer (state, content) {
    state.content = content
  },

  setHost (state, content) {
    state.lasthost = content
  },

  setHomedelivery (state, content) {
    state.content.item_homedelivery = content
  },

  resetHomedelivery (state) {
    state.content.item_homedelivery = defaultSet.item_homedelivery
  },

  resetPaymentMethod (state) {
    state.content.item_payment = defaultSet.item_payment
  }
}

export default {
  actions,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/customer.js